import e from "@dialpad/dialtone-tokens/layered/themes/tokens-115-colors.css?inline";
//#region themes/115.js
var t = { brand: {
	css: e,
	name: "115"
} };
//#endregion
export { t as default };
